
<b-modal ref="modal_form"
         :size="size"
         centered
         no-close-on-backdrop
         no-close-on-esc
         :hide-header="noHeader"
         v-on:hidden="handleHidden"
         hide-footer>
  <template v-slot:modal-header v-if="!noHeader">
    <slot name="header" v-bind:item="localItem"></slot>
  </template>
  <b-form v-on:input="handleInput($event)" novalidate validated>
    <slot name="fields" v-bind:item="localItem" v-bind:isnew="isNew"></slot>
    <b-button v-if="isNew" :disabled="isInvalid || !isDirty" variant="primary" class="mr-1" @click="save">Save</b-button>
    <b-button v-if="!isNew" :disabled="isInvalid || !isDirty" variant="primary" class="mr-1" @click="update">Update</b-button>
    <b-button variant="outline-secondary" class="mr-1" @click="cancel()" v-if="!noCancel">Cancel</b-button>
    <b-button v-if="!isNew && !isDirty && !noDestroy" class="mr-1" variant="link" @click="destroy()">Delete</b-button>
    <b-button v-if="isDirty" variant="link" class="mr-1" @click="reset()">Reset</b-button>
  </b-form>
</b-modal>
